import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import { getOffset } from '@app/libs/pagination';
import { getDrafts, GetDraftsResponse } from '@app/store/transport-layer/form/drafts';

export const queryKeyPrefix = 'drafts';

interface ListDraftsParams {
  page: number;
  limit: number;
  count?: boolean;
  keyword?: string;
  assigned?: boolean;
}

interface Options<TData, TError>
  extends UseQueryOptions<GetDraftsResponse, TError, TData, (string | ListDraftsParams)[]> {}

export default function useDrafts<TData = GetDraftsResponse, TError = AxiosError>(
  workspaceId: string,
  params: ListDraftsParams,
  options?: Options<TData, TError>
) {
  const { page, limit } = params;

  return useQuery(
    [queryKeyPrefix, ...(params ? [params] : [])],
    () => getDrafts(workspaceId, { ...params, offset: getOffset(page, limit), limit }),
    options
  );
}
